/* eslint-disable */
import _ from 'lodash';

const { round } = require('./utils');

const classQuote = ({
  classIns: {
    weightingFactor,
    protectionFactor,
  },
  coverageLevel,
  declaredShare,
  expectedPrice,
  loadingFactor,
  milkProduction,
  simPrices,
  simYieldAdjustmentFactor,
  calculating,
}, { subsidyPercent }) => {
  if (calculating) return 0;

  const cpwf = parseFloat(weightingFactor);
  const expClassIIIPrice = round(expectedPrice.classIII.avg * cpwf);
  const expClassIVPrice = round(expectedPrice.classIV.avg * (1 - cpwf));
  const expTotalClass = ((expClassIIIPrice + expClassIVPrice) * milkProduction);
  const expRevAmount = Math.ceil(expTotalClass / 100) || 0;
  const expRevGuarantee = Math.ceil((expRevAmount * coverageLevel) / 100) || 0;
  const butterFatSimPrices = _.get(simPrices, `butterFat`, null);
  const proteinSimPrices = _.get(simPrices, `protein`, null);
  const otherSolidsSimPrices = _.get(simPrices, `otherSolids`, null);
  const nonfatSolidsSimPrices = _.get(simPrices, `nonfatSolids`, null);

  if (!butterFatSimPrices || !proteinSimPrices || !otherSolidsSimPrices || !nonfatSolidsSimPrices) {
    return 0;
  }

  const calcSimRevAmounts = () => {
    const simRevenueAmounts = [];

    SEQUENCE.forEach((idx) => {
      const classIIIPrice = round(simPrices.classIII[idx] * cpwf);
      const classIVPrice = round(simPrices.classIV[idx] * (1 - cpwf));
      const combinedPrice = round(classIIIPrice + classIVPrice);
      const adjustmentFactor = (round(milkProduction * simYieldAdjustmentFactor[idx])) / 100.00;

      simRevenueAmounts[idx] = Math.ceil(combinedPrice * adjustmentFactor);
    });

    return simRevenueAmounts;
  };

  const simRevAmounts = calcSimRevAmounts();
  const simLoss = simRevAmounts.map((value) => round(Math.max(expRevGuarantee - value, 0), 2));
  const calcSimLossAverage = () => {
    const sum = simLoss.reduce((a, b) => a + b, 0);
    const average = sum / 5000;
    const baseline = (0.02 * milkProduction) / 100;
    return round(Math.max(average, baseline), 2);
  };
  const simLossAverage = calcSimLossAverage();
  const preliminaryTotalPremium = Math.ceil(simLossAverage * declaredShare * protectionFactor);
  const totalPremiumAmount = Math.ceil(preliminaryTotalPremium * loadingFactor) || 0;
  const liability = expRevGuarantee * declaredShare * protectionFactor || 0;
  const subsidyAmount = Math.ceil(totalPremiumAmount * subsidyPercent) || 0;
  const producerPremiumAmount = Math.max(Math.ceil(totalPremiumAmount - subsidyAmount), 1) || 0;

  return {
    expRevGuarantee,
    totalPremiumAmount,
    liability,
    subsidyAmount,
    producerPremiumAmount,
  };
};

export default classQuote;
